import { FiActivity, FiDatabase } from "react-icons/fi";
import * as s from "./BillToDateStyled";

type Variant = "channel" | "storage";

const CONFIG: Record<Variant, { icon: JSX.Element; title: string; subtitle: string }> = {
  channel: {
    icon: <FiActivity />,
    title: "No channel activity",
    subtitle: "No channel usage recorded\nfor this billing period",
  },
  storage: {
    icon: <FiDatabase />,
    title: "No storage usage",
    subtitle: "No storage allocations found\nfor this billing period",
  },
};

export default function BillToDateEmptyState({ variant }: { variant: Variant }) {
  const { icon, title, subtitle } = CONFIG[variant];
  return (
    <s.EmptyStateWrapper>
      <div className="icon-wrap">{icon}</div>
      <div className="empty-title">{title}</div>
      <div className="empty-subtitle">{subtitle}</div>
    </s.EmptyStateWrapper>
  );
}
